// Marker operations — place / enable / disable / set-active.
//
// Markers are positions on the main trackline: { segmentIdx, t }. The
// schema has four slots:
//   startFinish — required (always present)
//   startLine   — optional aux starting position
//   sectors[0]  — sector 1 closing line
//   sectors[1]  — sector 2 closing line
// Sectors are pair-managed (both or neither).

import { normalizeSectors } from '../../shared/markers.js';
import { pushHistory } from './history.js';

// Place / move a marker by name. For sector markers, also re-runs
// normalizeSectors so sectors[0] is always the lower-progress
// boundary; if a swap happens and the active marker referenced one of
// them, swap the activeMarker reference too so the user keeps editing
// what they meant to.
export function placeMarker(state, name, segIdx, t, notify) {
  const td = state.trackData;
  const newPos = { segmentIdx: segIdx, t };

  if (name === 'startFinish' || name === 'startLine') {
    td[name] = newPos;
  } else if (name === 'sector0' || name === 'sector1') {
    if (!Array.isArray(td.sectors)) td.sectors = [];
    while (td.sectors.length < 2) td.sectors.push(null);
    const idx = name === 'sector0' ? 0 : 1;
    td.sectors[idx] = newPos;

    if (td.sectors[0] && td.sectors[1]) {
      const wpCount = td.trackline.waypoints.length;
      const swapped = normalizeSectors(td.sectors, td.startFinish, wpCount);
      if (swapped && (state.activeMarker === 'sector0' || state.activeMarker === 'sector1')) {
        state.activeMarker = state.activeMarker === 'sector0' ? 'sector1' : 'sector0';
      }
    }
  } else {
    return;
  }
  pushHistory(state, notify);
}

export function setActiveMarker(state, name, notify) {
  if (state.activeMarker === name) return;
  state.activeMarker = name;
  notify();
}

// Enable the startLine marker. Defaults its position to the S/F line —
// the user typically slides it backward (upstream) along the racing
// line afterward, so starting it at S/F is a sensible "click here to
// add then drag" anchor.
export function enableStartLine(state, notify) {
  const td = state.trackData;
  if (td.startLine) return;
  td.startLine = { ...(td.startFinish || { segmentIdx: 0, t: 0.5 }) };
  pushHistory(state, notify);
}

export function disableStartLine(state, notify) {
  const td = state.trackData;
  if (!td.startLine) return;
  td.startLine = null;
  if (state.activeMarker === 'startLine') state.activeMarker = null;
  pushHistory(state, notify);
}

// Enable both sector boundaries at default positions ~1/3 and ~2/3
// around the lap relative to the trackline's segment count.
export function enableSectors(state, notify) {
  const td = state.trackData;
  const n = td.trackline.waypoints.length;
  if (n < 3) return;
  const s1 = { segmentIdx: Math.floor(n / 3), t: 0 };
  const s2 = { segmentIdx: Math.floor((2 * n) / 3), t: 0 };
  td.sectors = [s1, s2];
  pushHistory(state, notify);
}

export function disableSectors(state, notify) {
  const td = state.trackData;
  if (!Array.isArray(td.sectors) || td.sectors.length === 0) return;
  td.sectors = [];
  if (state.activeMarker === 'sector0' || state.activeMarker === 'sector1') state.activeMarker = null;
  pushHistory(state, notify);
}
